import { render, staticRenderFns } from "./CreateSecondaryScraper.vue?vue&type=template&id=5f08733b&"
import script from "./CreateSecondaryScraper.vue?vue&type=script&lang=js&"
export * from "./CreateSecondaryScraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports